export const DEFAULT_STALE_TIME = 1 * 60 * 1000; // 1 minute
